import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular/standalone';
import { AppCommonModule } from 'src/app/common.module';
import { MainDialogComponent } from 'src/app/components/main-dialog/main-dialog.component';
import { Site } from 'src/app/models/site.model';
import { SitesService } from 'src/app/services/sites.service';
import { AddFloorDialogComponent } from './add-floor.dialog';
import { AppAreaMapComponent } from './area-map.component';

@Component({
  selector: 'app-show-floor-dialog',
  templateUrl: './show-floor.dialog.html',
  styleUrls: ['./show-floor.dialog.scss'],
  imports: [
    AppCommonModule,
    CommonModule,
    MainDialogComponent,
    AppAreaMapComponent,
  ],
})
export class ShowFloorDialogComponent {
  private _modal = inject(ModalController);
  private modalCtrl = inject(ModalController);
  private navParams = inject(NavParams);
  private sitesService = inject(SitesService);

  itemS = signal(this.navParams.get<{ name: string; url: string }>('item'));
  siteS = signal(this.navParams.get<Site>('site'));
  disabledS = signal(this.navParams.get<boolean>('disabled') ?? false);

  imageElement = signal<HTMLImageElement>(null);

  setBlueprintImage(img: Event) {
    const el = img.target as HTMLImageElement;
    const imgElement = new Image();
    imgElement.src = this.itemS().url;
    imgElement.width = el.width;
    imgElement.height = el.height;
    imgElement.crossOrigin = 'anonymous';
    setTimeout(() => {
      this.imageElement.set(imgElement);
    }, 500);
  }

  changeBlueprint() {
    this.modalCtrl.create({ component: AddFloorDialogComponent, cssClass: ['stack-modal'], componentProps: { item: this.itemS() } }).then((m) => {
      m.present();

      m.onDidDismiss().then((data) => {
        if (data.data) {
          const existing = this.siteS().floors.find((it) => it.name === this.itemS().name);
          existing.url = data.data.url;
          this.itemS().url = existing.url;
          this.sitesService.updateOnly(this.siteS().guid, { floors: this.siteS().floors });
          this.imageElement.set(null);
        }
      });
    });
  }

  dismiss() {
    this._modal.dismiss();
  }
}
